function go_to_site(site_link, external) {    
    if (external) {
        window.open(site_link, '_blank').focus();
        return;
    }

    window.location.href = site_link;
}

function getHttpPrams(name){
    if(name=(new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)')).exec(location.search))
       return decodeURIComponent(name[1]);
 }

export { 
    go_to_site,
    getHttpPrams
 }